/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ChatMessageFeedback = {
    id: string;
    messageId: string;
    type: ChatMessageFeedback.type;
    negativeType?: ChatMessageFeedback.negativeType | null;
    negativeOther?: string | null;
    createdAt: string;
    updatedAt: string;
};

export namespace ChatMessageFeedback {

    export enum type {
        POSITIVE = 'positive',
        NEGATIVE = 'negative',
    }

    export enum negativeType {
        NOT_CORRECT = 'not_correct',
        UNFOLLOW_INSTRUCTIONS = 'unfollow_instructions',
        OTHER = 'other',
    }


}

